import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import moment from 'moment';
import addKeyword from './addKeyword';
import { IPSService } from '@/services/ipsServices';
import style from '@/views/components/filterItemManager/style.vue';

@Component({
  mixins: [style],
})
export default class SearchRecommend extends Vue {
  dataList: Array<SearchKeyWord> = [];

  loadingState = false;

  keywords = '';

  @Prop({ default: 0 })
    siteId;

  public selected = [];

  async mounted() {
    this.getData();
  }

  getData(): void {
    this.loadingState = true;
    const postParams = {
      siteId: this.siteId,
      type: 2,
      keyword: this.keywords,
      sort: 1,
      page: 1,
      pageSize: 1000,
    };
    IPSService.siteKeywordList({ postParams }).then((res) => {
      this.loadingState = false;
      this.dataList = res.list.map((i) => {
        i.updateTimeStr = moment(i.updateTime * 1000).format('YYYY-MM-DD HH:mm');
        return i;
      });
    });
  }

  /**
   * 输入框失焦排序
   * @param val
   * @param classId
   * @param parentId 1 一级排序 2 二级排序
   * @returns null
   */
  onBlurSort(val): void {
    if (val.sort === undefined) {
      this.$message.warning('请输入序号');
      return;
    }
    if (val.sort > 999 || Number(val.sort) > 999) {
      this.$message.warning('序号最大999');
      return;
    }
    const postParams = {
      siteId: this.siteId,
      id: val.id,
      sort: val.sort,
    };
    IPSService.siteKeywordSort({ postParams }).then((result) => {
      if (result) {
        this.$message.success('排序成功！');
        this.getData();
      }
    });
  }

  addKeywords(id = 0, desc = {}, keyword = '') {
    addKeyword
      .open({
        data: { desc, type: 2, keyword, id, siteId: this.siteId },
      })
      .then((result) => {
        if (result) {
          this.getData();
        }
      });
  }

  public batchDel(id = -1): void {
    let productIds = [];
    let message = '';
    if (id === -1) {
      if (!this.selected || !this.selected.length) {
        return;
      }
      productIds = this.selected.map(v => v.id);
      message = `确认将当前选中的${this.selected.length}个关键词删除？`;
    } else {
      productIds = [id];
      message = '确认将当前选中的关键词删除?';
    }
    this.$confirm(`${message}`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        IPSService.siteKeywordDelete({ postParams: { siteId: this.siteId, ids: productIds } }).then((res) => {
          if (res) {
            this.getData();
          }
        });
      }
    });
  }

  // 选中
  onSelected(val) {
    this.selected = val;
  }

  renderTableBtn(h, val) {
    const { id, desc = {}, keyword } = val;
    return (
      <div>
        <span class="scopeSpan" onClick={() => this.addKeywords(id, desc, keyword)}>
          编辑
        </span>
        <span class="scopeSpan" onClick={() => this.batchDel(id)}>
          删除
        </span>
      </div>
    );
  }

  render(h) {
    return (
      <div class="filter-item-list">
        <div class="messageBlock">
          <span class="redText">*&nbsp;</span>
          顾客进入搜索状态时给予推荐关键词（展示排序前10的关键字），点击可跳转至指定链接
        </div>
        <el-table v-loading={this.loadingState} data={this.dataList} element-loading-text="加载中" height={this.$store.state.windowHeight - 264} ref="table" tooltip-effect="light" on-selection-change={this.onSelected}>
          <el-table-column type="selection" width="50" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column type="index" label="#" width="50" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column label="推荐关键词" prop="keyword" show-overflow-tooltip />
          <el-table-column label="链接至" width="220" prop="linkToContent" show-overflow-tooltip />
          <el-table-column label="点击量" prop="viewNum" align="right" show-overflow-tooltip />
          <el-table-column
            label="排序"
            prop="sort"
            align="center"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return <el-input-number controls={false} v-model={scoped.row.sort} min={0} max={999} class="sort-keyword" onChange={this.onBlurSort.bind(this, scoped.row)} />;
                },
              },
            }}
          />
          <el-table-column label="更新人" prop="empName" show-overflow-tooltip />
          <el-table-column label="更新时间" prop="updateTimeStr" show-overflow-tooltip />
          <el-table-column
            label="操作"
            align="center"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return this.renderTableBtn(h, scoped.row);
                },
              },
            }}
          />
        </el-table>
        <div class="bottomWrapper">
          <el-button type="primary" onClick={() => this.addKeywords()}>
            添加
          </el-button>
          <span class={[(!this.selected || !this.selected.length) && 'disabled', 'scopeSpan r-mx-16 font-size-14']} onClick={() => this.batchDel()}>
            批量删除
          </span>
        </div>
      </div>
    );
  }
}
